webpackJsonp([0],{

/***/ 5007:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_work__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Lightblades__ = __webpack_require__(5064);
var mapStateToProps=function mapStateToProps(state){return{content:state.work.lightblades,next:state.work.intergalactic,prev:state.work.unionSquare};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{load:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(__WEBPACK_IMPORTED_MODULE_2__actions_work__["a" /* default */].fetch,dispatch)};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__pages_Lightblades__["a" /* default */]));

/***/ }),

/***/ 5012:
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(5027);

/**
 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @param {number} [size=array.length] The size of `array`.
 * @returns {Array} Returns `array`.
 */
function shuffleSelf(array, size) {
  var index = -1,
      length = array.length,
      lastIndex = length - 1;

  size = size === undefined ? length : size;
  while (++index < size) {
    var rand = baseRandom(index, lastIndex),
        value = array[rand];

    array[rand] = array[index];
    array[index] = value;
  }
  array.length = size;
  return array;
}

module.exports = shuffleSelf;


/***/ }),

/***/ 5013:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WorkNav__ = __webpack_require__(5014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WorkNav__["a"]; });


/***/ }),

/***/ 5014:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Image__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(5015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(23);
var WorkTile=function WorkTile(_ref){var work=_ref.work;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],Object.assign({to:work.link},__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* halfWidth */],__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* fullWidthSm */],__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* relative */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Image__["a" /* default */],{sources:work.headerImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* center */],__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* linkStyles */],__WEBPACK_IMPORTED_MODULE_3__styles__["h" /* workTitleWrapper */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',__WEBPACK_IMPORTED_MODULE_3__styles__["g" /* workTitle */],work.title)));};var WorkNav=function WorkNav(_ref2){var prev=_ref2.prev,next=_ref2.next;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* relative */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* anchorTopLg */],__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* noPointer */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',Object.assign({},__WEBPACK_IMPORTED_MODULE_3__styles__["c" /* header */],__WEBPACK_IMPORTED_MODULE_3__styles__["e" /* noPointer */]),'Other projects'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* absolute */],__WEBPACK_IMPORTED_MODULE_4__styles__["i" /* hideOnSm */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{width:'100%',height:'50%',viewBox:'0 0 100 50',xmlns:'http://www.w3.org/2000/svg',align:'xMaxYMax'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{points:'0,0 100,0 50,50, 0,0',fill:'#fff'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_4__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkTile,{work:prev}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WorkTile,{work:next})));};/* harmony default export */ __webpack_exports__["a"] = (WorkNav);

/***/ }),

/***/ 5015:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return relative; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return absolute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return anchorTopLg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return noPointer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return linkStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return workTitleWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return workTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_typography__ = __webpack_require__(36);
var relative=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'relative'});var absolute=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'absolute',width:'100%',top:0,left:0,zIndex:1});var anchorTopLg=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({'@media(min-width: 48em)':{position:'absolute',width:'50%',top:0,left:'50%',transform:'translate(-50%)',zIndex:1}});var header=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'relative',margin:__WEBPACK_IMPORTED_MODULE_1__utils_typography__["a" /* default */].rhythm(2)+' 0',color:'rgba(0, 0, 0, 0.8)',zIndex:2,textAlign:'center',textTransform:'uppercase'});var noPointer=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({pointerEvents:'none'});var linkStyles=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({color:'rgba(0, 0, 0, 0.8)',backgroundImage:'none',textShadow:'none','@media(max-width: 48em)':{color:'white'}});var workTitleWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'absolute',padding:__WEBPACK_IMPORTED_MODULE_1__utils_typography__["a" /* default */].rhythm(1),top:'50%',left:'50%',transform:'translate(-50%)',border:'1px solid white'});var workTitle=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({margin:0,color:'white'});

/***/ }),

/***/ 5016:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(5017);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });


/***/ }),

/***/ 5017:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(5018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Loader=function(_React$Component){_inherits(Loader,_React$Component);function Loader(){_classCallCheck(this,Loader);return _possibleConstructorReturn(this,(Loader.__proto__||Object.getPrototypeOf(Loader)).apply(this,arguments));}_createClass(Loader,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* wrapper */],__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* center */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'Loading'));}}]);return Loader;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),

/***/ 5018:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return wrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
var wrapper=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'fixed',display:'flex',justifyContent:'center',alignItems:'center',top:0,left:0,width:'100%',height:'100vh',zIndex:101,background:'white'});

/***/ }),

/***/ 5019:
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(5033),
    keys = __webpack_require__(110);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),

/***/ 5020:
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(2059),
    isArrayLike = __webpack_require__(108),
    isIndex = __webpack_require__(2060),
    isObject = __webpack_require__(106);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),

/***/ 5021:
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(5025);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 5022:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),

/***/ 5023:
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 5024:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(5044);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5043)))

/***/ }),

/***/ 5025:
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(5026);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 5026:
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(106),
    isSymbol = __webpack_require__(109);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 5027:
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor,
    nativeRandom = Math.random;

/**
 * The base implementation of `_.random` without support for returning
 * floating-point numbers.
 *
 * @private
 * @param {number} lower The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the random number.
 */
function baseRandom(lower, upper) {
  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
}

module.exports = baseRandom;


/***/ }),

/***/ 5028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Video__ = __webpack_require__(5039);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Video__["a"]; });


/***/ }),

/***/ 5030:
/***/ (function(module, exports, __webpack_require__) {

var arraySampleSize = __webpack_require__(5031),
    baseSampleSize = __webpack_require__(5032),
    isArray = __webpack_require__(24),
    isIterateeCall = __webpack_require__(5020),
    toInteger = __webpack_require__(5021);

/**
 * Gets `n` random elements at unique keys from `collection` up to the
 * size of `collection`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @param {number} [n=1] The number of elements to sample.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the random elements.
 * @example
 *
 * _.sampleSize([1, 2, 3], 2);
 * // => [3, 1]
 *
 * _.sampleSize([1, 2, 3], 4);
 * // => [2, 3, 1]
 */
function sampleSize(collection, n, guard) {
  if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
    n = 1;
  } else {
    n = toInteger(n);
  }
  var func = isArray(collection) ? arraySampleSize : baseSampleSize;
  return func(collection, n);
}

module.exports = sampleSize;


/***/ }),

/***/ 5031:
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(5022),
    copyArray = __webpack_require__(5023),
    shuffleSelf = __webpack_require__(5012);

/**
 * A specialized version of `_.sampleSize` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function arraySampleSize(array, n) {
  return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
}

module.exports = arraySampleSize;


/***/ }),

/***/ 5032:
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(5022),
    shuffleSelf = __webpack_require__(5012),
    values = __webpack_require__(5019);

/**
 * The base implementation of `_.sampleSize` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @param {number} n The number of elements to sample.
 * @returns {Array} Returns the random elements.
 */
function baseSampleSize(collection, n) {
  var array = values(collection);
  return shuffleSelf(array, baseClamp(n, 0, array.length));
}

module.exports = baseSampleSize;


/***/ }),

/***/ 5033:
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(2062);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),

/***/ 5034:
/***/ (function(module, exports, __webpack_require__) {

var arrayShuffle = __webpack_require__(5035),
    baseShuffle = __webpack_require__(5036),
    isArray = __webpack_require__(24);

/**
 * Creates an array of shuffled values, using a version of the
 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 * @example
 *
 * _.shuffle([1, 2, 3, 4]);
 * // => [4, 1, 3, 2]
 */
function shuffle(collection) {
  var func = isArray(collection) ? arrayShuffle : baseShuffle;
  return func(collection);
}

module.exports = shuffle;


/***/ }),

/***/ 5035:
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(5023),
    shuffleSelf = __webpack_require__(5012);

/**
 * A specialized version of `_.shuffle` for arrays.
 *
 * @private
 * @param {Array} array The array to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function arrayShuffle(array) {
  return shuffleSelf(copyArray(array));
}

module.exports = arrayShuffle;


/***/ }),

/***/ 5036:
/***/ (function(module, exports, __webpack_require__) {

var shuffleSelf = __webpack_require__(5012),
    values = __webpack_require__(5019);

/**
 * The base implementation of `_.shuffle`.
 *
 * @private
 * @param {Array|Object} collection The collection to shuffle.
 * @returns {Array} Returns the new shuffled array.
 */
function baseShuffle(collection) {
  return shuffleSelf(values(collection));
}

module.exports = baseShuffle;


/***/ }),

/***/ 5039:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_vimeo__ = __webpack_require__(5040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_vimeo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_vimeo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Image__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css__ = __webpack_require__(5048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(5050);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Video=function(_React$Component){_inherits(Video,_React$Component);function Video(props){_classCallCheck(this,Video);var _this=_possibleConstructorReturn(this,(Video.__proto__||Object.getPrototypeOf(Video)).call(this,props));_this.togglePlaying=function(){_this.setState({isPlaying:!_this.state.isPlaying});};_this.play=function(){_this.setState({isPlaying:true});};_this.state={isPlaying:false};_this.timeout=0;return _this;}_createClass(Video,[{key:'render',value:function render(){var _this2=this;var _props=this.props,videoId=_props.videoId,sources=_props.sources;var isPlaying=this.state.isPlaying;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_5__styles__["b" /* relative */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_5__styles__["c" /* videoWrapper */],Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(isPlaying?{opacity:0}:{})),!isPlaying&&[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',Object.assign({className:'vimeo-play-button',type:'button'},__WEBPACK_IMPORTED_MODULE_5__styles__["a" /* pointerless */],{key:'button'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',viewBox:'0 0 100 100',xmlns:'http://www.w3.org/2000/svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:'M79.674,53.719c2.59-2.046,2.59-5.392,0-7.437L22.566,1.053C19.977-0.993,18,0.035,18,3.335v93.331c0,3.3,1.977,4.326,4.566,2.281L79.674,53.719z'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'image',onClick:function onClick(){return _this2.play();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Image__["a" /* default */],{sources:sources,ratio:'16x9'}))]),isPlaying&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_vimeo___default.a,{videoId:videoId,autoplay:true}));}}]);return Video;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),

/***/ 5040:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _keymirror = __webpack_require__(5041);

var _keymirror2 = _interopRequireDefault(_keymirror);

var _jsonp = __webpack_require__(5042);

var _jsonp2 = _interopRequireDefault(_jsonp);

var _debug = __webpack_require__(5024);

var _debug2 = _interopRequireDefault(_debug);

var _PlayButton = __webpack_require__(5046);

var _PlayButton2 = _interopRequireDefault(_PlayButton);

var _Spinner = __webpack_require__(5047);

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _debug2.default)('vimeo:player');
var noop = function noop() {};
var playerEvents = (0, _keymirror2.default)({
  cueChange: null,
  ended: null,
  loaded: null,
  pause: null,
  play: null,
  progress: null,
  seeked: null,
  textTrackChange: null,
  timeUpdate: null,
  volumeChange: null
});

function capitalize() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return str.charAt(0).toUpperCase() + str.substring(1);
}

function getFuncForEvent(event, props) {
  return props['on' + capitalize(event)] || function () {};
}

function post(method, value, player, playerOrigin) {
  try {
    player.contentWindow.postMessage({ method: method, value: value }, playerOrigin);
  } catch (err) {
    return err;
  }
  return null;
}

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, _class);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      imageLoaded: false,
      playerOrigin: '*',
      showingVideo: _this.props.autoplay,
      thumb: null
    }, _this.addMessageListener = function () {
      var _context;

      var addEventListener = typeof window !== 'undefined' ? (_context = window).addEventListener.bind(_context) : noop;

      addEventListener('message', _this.onMessage);
    }, _this.onError = function (err) {
      if (_this.props.onError) {
        _this.props.onError(err);
      }
      throw err;
    }, _this.onMessage = function (_ref2) {
      var origin = _ref2.origin,
          data = _ref2.data;
      var onReady = _this.props.onReady;
      var playerOrigin = _this.state.playerOrigin;


      if (playerOrigin === '*') {
        _this.setState({
          playerOrigin: origin
        });
      }

      // Handle messages from the vimeo player only
      if (!/^https?:\/\/player.vimeo.com/.test(origin)) {
        return false;
      }

      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (err) {
          debug('error parsing message', err);
          data = { event: '' };
        }
      }

      if (data.event === 'ready') {
        debug('player ready');
        _this.onReady(_this._player, playerOrigin === '*' ? origin : playerOrigin);
        return onReady(data);
      }
      if (!data.event) {
        // we get messages when the first event callbacks are added to the frame
        return;
      }
      debug('firing event: ', data.event);
      getFuncForEvent(data.event, _this.props)(data);
    }, _this.onReady = function (player, playerOrigin) {
      Object.keys(playerEvents).forEach(function (event) {
        var err = post('addEventListener', event.toLowerCase(), player, playerOrigin);
        if (err) {
          _this.onError(err);
        }
      });
    }, _this.playVideo = function (e) {
      e.preventDefault();
      _this.setState({ showingVideo: true });
    }, _this.getIframeUrl = function () {
      var videoId = _this.props.videoId;

      var query = _this.getIframeUrlQuery();
      return '//player.vimeo.com/video/' + videoId + '?' + query;
    }, _this.getIframeUrlQuery = function () {
      var str = [];
      Object.keys(_this.props.playerOptions).forEach(function (key) {
        str.push(key + '=' + _this.props.playerOptions[key]);
      });

      return str.join('&');
    }, _this.fetchVimeoData = function () {
      if (_this.state.imageLoaded) {
        return;
      }
      var id = _this.props.videoId;

      (0, _jsonp2.default)('//vimeo.com/api/v2/video/' + id + '.json', {
        prefix: 'vimeo'
      }, function (err, res) {
        if (err) {
          debug('jsonp err: ', err.message);
          _this.onError(err);
        }
        debug('jsonp response', res);
        _this.setState({
          thumb: res[0].thumbnail_large,
          imageLoaded: true
        });
      });
    }, _this.renderImage = function () {
      if (_this.state.showingVideo || !_this.state.imageLoaded) {
        return;
      }

      var style = {
        backgroundImage: 'url(' + _this.state.thumb + ')',
        display: !_this.state.showingVideo ? 'block' : 'none',
        height: '100%',
        width: '100%'
      };

      var playButton = _this.props.playButton ? (0, _react.cloneElement)(_this.props.playButton, { onClick: _this.playVideo }) : _react2.default.createElement(_PlayButton2.default, { onClick: _this.playVideo });

      return _react2.default.createElement(
        'div',
        {
          className: 'vimeo-image',
          style: style },
        playButton
      );
    }, _this.renderIframe = function () {
      if (!_this.state.showingVideo) {
        return;
      }

      _this.addMessageListener();

      var embedVideoStyle = {
        display: _this.state.showingVideo ? 'block' : 'none',
        height: '100%',
        width: '100%'
      };

      return _react2.default.createElement(
        'div',
        {
          className: 'vimeo-embed',
          style: embedVideoStyle },
        _react2.default.createElement('iframe', {
          frameBorder: '0',
          ref: function ref(el) {
            _this._player = el;
          },
          src: _this.getIframeUrl() })
      );
    }, _this.renderLoading = function (imageLoaded, loadingElement) {
      if (imageLoaded) {
        return;
      }
      if (loadingElement) {
        return loadingElement;
      }
      return _react2.default.createElement(_Spinner2.default, null);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(_class, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.videoId !== this.props.videoId) {
        this.setState({
          thumb: null,
          imageLoaded: false,
          showingVideo: false
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchVimeoData();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.fetchVimeoData();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _context2;

      var removeEventListener = typeof window !== 'undefined' ? (_context2 = window).removeEventListener.bind(_context2) : noop;

      removeEventListener('message', this.onMessage);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.props.className },
        this.renderLoading(this.state.imageLoaded, this.props.loading),
        this.renderImage(),
        this.renderIframe()
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.displayName = 'Vimeo';
_class.propTypes = {
  autoplay: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  loading: _propTypes2.default.element,
  playButton: _propTypes2.default.node,
  playerOptions: _propTypes2.default.object,
  videoId: _propTypes2.default.string.isRequired,

  // event callbacks
  onCueChange: _propTypes2.default.func,
  onEnded: _propTypes2.default.func,
  onError: _propTypes2.default.func,
  onLoaded: _propTypes2.default.func,
  onPause: _propTypes2.default.func,
  onPlay: _propTypes2.default.func,
  onProgress: _propTypes2.default.func,
  onReady: _propTypes2.default.func,
  onSeeked: _propTypes2.default.func,
  onTextTrackChanged: _propTypes2.default.func,
  onTimeUpdate: _propTypes2.default.func,
  onVolumeChange: _propTypes2.default.func
};

_class.defaultProps = function () {
  var defaults = Object.keys(playerEvents).concat(['ready']).reduce(function (defaults, event) {
    defaults['on' + capitalize(event)] = noop;
    return defaults;
  }, {});

  defaults.className = 'vimeo';
  defaults.playerOptions = { autoplay: 1 };
  defaults.autoplay = false;
  return defaults;
}();

exports.default = _class;
module.exports = exports['default'];

/***/ }),

/***/ 5041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014 Facebook, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */



/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function(obj) {
  var ret = {};
  var key;
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;


/***/ }),

/***/ 5042:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */

var debug = __webpack_require__(5024)('jsonp');

/**
 * Module exports.
 */

module.exports = jsonp;

/**
 * Callback index.
 */

var count = 0;

/**
 * Noop function.
 */

function noop(){}

/**
 * JSONP handler
 *
 * Options:
 *  - param {String} qs parameter (`callback`)
 *  - prefix {String} qs parameter (`__jp`)
 *  - name {String} qs parameter (`prefix` + incr)
 *  - timeout {Number} how long after a timeout error is emitted (`60000`)
 *
 * @param {String} url
 * @param {Object|Function} optional options / callback
 * @param {Function} optional callback
 */

function jsonp(url, opts, fn){
  if ('function' == typeof opts) {
    fn = opts;
    opts = {};
  }
  if (!opts) opts = {};

  var prefix = opts.prefix || '__jp';

  // use the callback name that was passed if one was provided.
  // otherwise generate a unique name by incrementing our counter.
  var id = opts.name || (prefix + (count++));

  var param = opts.param || 'callback';
  var timeout = null != opts.timeout ? opts.timeout : 60000;
  var enc = encodeURIComponent;
  var target = document.getElementsByTagName('script')[0] || document.head;
  var script;
  var timer;


  if (timeout) {
    timer = setTimeout(function(){
      cleanup();
      if (fn) fn(new Error('Timeout'));
    }, timeout);
  }

  function cleanup(){
    if (script.parentNode) script.parentNode.removeChild(script);
    window[id] = noop;
    if (timer) clearTimeout(timer);
  }

  function cancel(){
    if (window[id]) {
      cleanup();
    }
  }

  window[id] = function(data){
    debug('jsonp got', data);
    cleanup();
    if (fn) fn(null, data);
  };

  // add qs component
  url += (~url.indexOf('?') ? '&' : '?') + param + '=' + enc(id);
  url = url.replace('?&', '?');

  debug('jsonp req "%s"', url);

  // create script
  script = document.createElement('script');
  script.src = url;
  target.parentNode.insertBefore(script, target);

  return cancel;
}


/***/ }),

/***/ 5043:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 5044:
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(5045);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),

/***/ 5045:
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),

/***/ 5046:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(2);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        {
          className: 'vimeo-play-button',
          onClick: this.props.onClick,
          type: 'button' },
        _react2.default.createElement(
          'svg',
          {
            version: '1.1',
            viewBox: '0 0 100 100',
            xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('path', { d: 'M79.674,53.719c2.59-2.046,2.59-5.392,0-7.437L22.566,1.053C19.977-0.993,18,0.035,18,3.335v93.331c0,3.3,1.977,4.326,4.566,2.281L79.674,53.719z' })
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.displayName = 'PlayButton';
_class.propTypes = {
  onClick: _propTypes2.default.func
};
exports.default = _class;
module.exports = exports['default'];

/***/ }),

/***/ 5047:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


/*
 * React component for Vimeo Loading Spinner created and rendered.
 * SVG Path is used for creating the spinner.
 */
var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'vimeo-loading' },
        _react2.default.createElement(
          'svg',
          {
            height: '32',
            viewBox: '0 0 32 32',
            width: '32',
            xmlns: 'http://www.w3.org/2000/svg' },
          _react2.default.createElement('path', {
            d: 'M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4',
            opacity: '.25' }),
          _react2.default.createElement('path', { d: 'M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z' })
        )
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.displayName = 'Spinner';
exports.default = _class;
module.exports = exports['default'];

/***/ }),

/***/ 5048:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5049);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(4997)(content, options);
if(content.locals) module.exports = content.locals;


/***/ }),

/***/ 5049:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(4996)(true);
// imports


// module
exports.push([module.i, ".vimeo-embed,.vimeo-image,.vimeo-image:after{position:absolute;top:0;left:0;width:100%;height:100%}.vimeo{position:relative;padding-bottom:56.25%;background:#e2e2e2}.vimeo iframe{border:0}.vimeo-image{background-position:50%;background-size:100% auto}.vimeo-image:after{z-index:1;display:block;content:\"\";background:rgba(0,0,0,.3)}.vimeo-loading,.vimeo-play-button{top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);-ms-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}.vimeo-play-button{z-index:2;position:absolute;padding:0;width:70px;border:0;background:none}.vimeo-play-button:focus{outline:none}.vimeo-play-button svg{fill:#fff;-webkit-filter:drop-shadow(0 1px 1px rgba(0,0,0,.8));filter:drop-shadow(0 1px 1px rgba(0,0,0,.8))}.vimeo-loading{z-index:4;position:absolute;width:32px;height:32px}.vimeo-loading svg{fill:#000;-webkit-transform-origin:50% 50%;-ms-transform-origin:50% 50%;transform-origin:50% 50%;-webkit-animation:spinner .8s infinite linear;animation:spinner .8s infinite linear}.vimeo-embed iframe{width:100%;height:100%}@-webkit-keyframes spinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spinner{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}", "", {"version":3,"sources":["/Users/lucasswick/Projects/lucastswick-v4/src/components/Video/styles.css"],"names":[],"mappings":"AAAA,6CAGE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,WAAa,CACd,AACD,OACE,kBAAmB,AACnB,sBAAuB,AACvB,kBAAoB,CACrB,AACD,cACE,QAAU,CACX,AACD,aACE,wBAAmC,AACnC,yBAA2B,CAC5B,AACD,mBACE,UAAW,AACX,cAAe,AACf,WAAY,AACZ,yBAA+B,CAChC,AACD,kCAEE,QAAS,AACT,SAAU,AACV,oDAAqD,AACjD,gDAAiD,AAC7C,2CAA6C,CACtD,AACD,mBACE,UAAW,AACX,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,SAAU,AACV,eAAiB,CAClB,AACD,yBACE,YAAc,CACf,AACD,uBACE,UAAW,AACX,qDAA0D,AAC1D,4CAAkD,CACnD,AACD,eACE,UAAW,AACX,kBAAmB,AACnB,WAAY,AACZ,WAAa,CACd,AACD,mBACE,UAAW,AACX,iCAAkC,AAC9B,6BAA8B,AAC1B,yBAA0B,AAClC,8CAAgD,AAChD,qCAAwC,CACzC,AACD,oBACE,WAAY,AACZ,WAAa,CACd,AACD,2BACE,GACE,+BAAgC,AACxB,sBAAwB,CACjC,AACD,GACE,gCAAkC,AAC1B,uBAA0B,CACnC,CACF,AACD,mBACE,GACE,+BAAgC,AACxB,sBAAwB,CACjC,AACD,GACE,gCAAkC,AAC1B,uBAA0B,CACnC,CACF","file":"styles.css","sourcesContent":[".vimeo-image,\n.vimeo-image:after,\n.vimeo-embed {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.vimeo {\n  position: relative;\n  padding-bottom: 56.25%;\n  background: #e2e2e2;\n}\n.vimeo iframe {\n  border: 0;\n}\n.vimeo-image {\n  background-position: center center;\n  background-size: 100% auto;\n}\n.vimeo-image:after {\n  z-index: 1;\n  display: block;\n  content: '';\n  background: rgba(0, 0, 0, 0.3);\n}\n.vimeo-play-button,\n.vimeo-loading {\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translateX(-50%) translateY(-50%);\n      -ms-transform: translateX(-50%) translateY(-50%);\n          transform: translateX(-50%) translateY(-50%);\n}\n.vimeo-play-button {\n  z-index: 2;\n  position: absolute;\n  padding: 0;\n  width: 70px;\n  border: 0;\n  background: none;\n}\n.vimeo-play-button:focus {\n  outline: none;\n}\n.vimeo-play-button svg {\n  fill: #fff;\n  -webkit-filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.8));\n  filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.8));\n}\n.vimeo-loading {\n  z-index: 4;\n  position: absolute;\n  width: 32px;\n  height: 32px;\n}\n.vimeo-loading svg {\n  fill: #000;\n  -webkit-transform-origin: 50% 50%;\n      -ms-transform-origin: 50% 50%;\n          transform-origin: 50% 50%;\n  -webkit-animation: spinner 0.8s infinite linear;\n  animation: spinner 0.8s infinite linear;\n}\n.vimeo-embed iframe {\n  width: 100%;\n  height: 100%;\n}\n@-webkit-keyframes spinner {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes spinner {\n  from {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5050:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return videoWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return relative; });
/* unused harmony export absolute */
/* unused harmony export img */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pointerless; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
var videoWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({opacity:1,transition:'opacity 0.3s ease-out'});var relative=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'relative'});var absolute=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'absolute',width:'100%',top:0,left:0,zIndex:1});var img=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({display:'block',marginBottom:0});var pointerless=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({pointerEvents:'none'});

/***/ }),

/***/ 5052:
/***/ (function(module, exports, __webpack_require__) {

var baseRandom = __webpack_require__(5027);

/**
 * A specialized version of `_.sample` for arrays.
 *
 * @private
 * @param {Array} array The array to sample.
 * @returns {*} Returns the random element.
 */
function arraySample(array) {
  var length = array.length;
  return length ? array[baseRandom(0, length - 1)] : undefined;
}

module.exports = arraySample;


/***/ }),

/***/ 5064:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(2058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter__ = __webpack_require__(5065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sample__ = __webpack_require__(5067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_sample___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_sample__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize__ = __webpack_require__(5030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__ = __webpack_require__(5034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Image__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Video__ = __webpack_require__(5028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_WorkNav__ = __webpack_require__(5013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ImageCopyBlock__ = __webpack_require__(5069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Loader__ = __webpack_require__(5016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Animated__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__styles__ = __webpack_require__(23);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getImage=function getImage(folder,filename,i){return[{srcSet:__webpack_require__(44)("./"+folder+'/'+filename+'-thumb-'+i+'.jpg'),media:'(max-width: 100px)'},{srcSet:__webpack_require__(44)("./"+folder+'/'+filename+'-sm-'+i+'.jpg'),media:'(max-width: 720px)'},{srcSet:__webpack_require__(44)("./"+folder+'/'+filename+'-'+i+'.jpg')}];};var getImages=function getImages(folder,filename,count){var images=[];for(var i=1;i<=count;i++){images.push([{srcSet:__webpack_require__(44)("./"+folder+'/'+filename+'-sm-'+i+'.jpg')}]);}return images;};var cloudsImages=getImages('lightblades','lightblades-installation-by-lucastswick-clouds',4);var warpImages=getImages('lightblades','lightblades-installation-by-lucastswick-warp',3);var fractalPoster=getImage('lightblades','lightblades-installation-by-lucastswick-fractal',Math.floor(Math.random()*2+1));var nightmarePoster=getImage('lightblades','lightblades-installation-by-lucastswick-nightmare',Math.floor(Math.random()*2+1));var conceptPoster=getImage('lightblades','lightblades-installation-by-lucastswick-in-context',1);var lusterPoster=getImage('lightblades','lightblades-installation-by-lucastswick-luster',Math.floor(Math.random()*2+1));// const lightbladesMovie = sample(['249484538', '262678548', '262678176']);
var fractalMovie=__WEBPACK_IMPORTED_MODULE_4_lodash_sample___default()(['262679383','262679922']);var lusterMovie='262700185';var nightmareMovie='262700645';var row1=function row1(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_13__styles__["d" /* fullWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Image__["a" /* default */],{sources:image,ratio:'16x9'}));};var row2=function row2(image,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_13__styles__["f" /* halfWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Image__["a" /* default */],{sources:image,ratio:'16x9'}));};var row3=function row3(image,index){var ratio=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'16x9';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_13__styles__["v" /* thirdWidth */],{key:'image-'+index}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Image__["a" /* default */],{sources:image,ratio:ratio}));};var Lightblades=function(_Component){_inherits(Lightblades,_Component);function Lightblades(props){_classCallCheck(this,Lightblades);var _this=_possibleConstructorReturn(this,(Lightblades.__proto__||Object.getPrototypeOf(Lightblades)).call(this,props));_this.state={set1:[],cloudsImages:[],warpImages:[]};return _this;}_createClass(Lightblades,[{key:'componentWillMount',value:function componentWillMount(){this.props.load();var fractal={title:'Fractal Planet',excerpt:"This shiny geometric concept speaks to the building's technological leadership.",headerImage:fractalPoster,video:fractalMovie};var luster={title:'Luster',excerpt:'This concept falls in and out of sync, reminding us that even if things seem chaotic, order eventually returns. ',headerImage:lusterPoster,video:lusterMovie};var nightmare={title:'Memory',excerpt:'This piece only plays after 2am when people people should be asleep. The fuzzy shapes overlap to create connections, symbolizing what happens to our memories when we dream.',headerImage:nightmarePoster,video:nightmareMovie};this.setState({fractal:fractal,luster:luster,nightmare:nightmare,cloudsImages:cloudsImages,warpImages:warpImages});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){if(nextProps.content&&nextProps.content.images&&!this.state.set1.length){var images=__WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(nextProps.content.images,function(image,index){return index!==nextProps.content.headerIndex;});var set1=__WEBPACK_IMPORTED_MODULE_5_lodash_sampleSize___default()(__WEBPACK_IMPORTED_MODULE_6_lodash_shuffle___default()(images),4);this.setState({set1:set1});}}},{key:'render',value:function render(){var content=this.props.content;if(!content){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_Loader__["a" /* default */],null);}var _props=this.props,prev=_props.prev,next=_props.next,headerImage=_props.content.headerImage;var _state=this.state,set1=_state.set1,fractal=_state.fractal,luster=_state.luster,nightmare=_state.nightmare,cloudsImages=_state.cloudsImages,warpImages=_state.warpImages;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet___default.a,{title:'Lightblades by lucastswick',description:'The Lightblades are a 3-story tall generative art installation in Portland',meta:[{property:'og:image:url',content:'https://generativeartist.com'+headerImage[2].srcSet},{property:'twitter:image',content:'https://generativeartist.com'+headerImage[2].srcSet}]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_13__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],{as:'h1'},'Lightblades'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],{delay:150},'A 3-story tall generative art installation in Portland'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],{delay:300},'In 2017 I worked with the team at',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'nofollow noopener noreferrer',href:'http://mezr.com/'},'MEZR'),' ','to create a generative art installation that runs on two 3-story tall LED lightblades. The lightblades flank Portland\'s newest creative space on Division and 25th, and will continuously create new art for years.')),row1(headerImage,1),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_13__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],{as:'h2'},'Programming'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],null,'The goal for the project was to create a system that continuously creates new visuals based on naturally-occuring phenomena. I concepted and programmed ten pieces that evolve over time, never repeating and continuously mesmerizing.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ImageCopyBlock__["b" /* ImageCopyBlock */],{item:fractal,showAllOnSmall:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ImageCopyBlock__["a" /* CopyImageBlock */],{item:luster,showAllOnSmall:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ImageCopyBlock__["b" /* ImageCopyBlock */],{item:nightmare,showAllOnSmall:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_13__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',null,'The Story'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],null,'I developed the concepts to be in sync with the rhythms of the day. In the morning, colors are chosen from photos of sunrises to create warmth, in the evening cooler blues are used as the sun goes down.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],null,'By following nature\'s lead, the installation becomes part of the community.')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_13__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(set1,function(image,index){if(index%4===0){return row1(image,index);}else{return row3(image,index,'16x9');}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_13__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(warpImages,function(image,index){return row3(image,index,'1x1');})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_13__styles__["x" /* wrapper */],__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(cloudsImages,function(image,index){return row2(image,index);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',__WEBPACK_IMPORTED_MODULE_13__styles__["u" /* textContainer */],__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],null,'I have many people to thank for giving me a giant canvas to make art on.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],null,'To',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'http://eichingersculpture.com/',target:'_blank',rel:'nofollow noopener noreferrer'},'Marty Eichinger'),', the client who trusted my artist intuition and was never prescriptive, Matt Scheick: project fabricator, Adrien \'Finch\' Thebo: engineer of the translation layer that puts my pixels on the LEDs, and Talik Eichinger: the glue that held everything together, thank you. Without the talent and dedication of the entire team at MEZR, this project would not exist.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],null,'I\'d also like to thank the community at',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:'https://www.shadertoy.com/',target:'_blank',rel:'nofollow noopener noreferrer'},'shadertoy'),', who has been a continuous source of learning and inspiration for me.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],{as:'h2'},'I want to see it'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Animated__["a" /* default */],null,'We\'re wrapping up the final details on the hardware and it\'ll be live soon. Follow me on',' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank',rel:'nofollow noopener noreferrer',href:'https://twitter.com/lucastswick'},'Twitter'),' ','for the launch date!')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_13__styles__["w" /* wideContainer */],__WEBPACK_IMPORTED_MODULE_13__styles__["r" /* removePaddingTop */]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_Video__["a" /* default */],{videoId:'262680431',sources:conceptPoster})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_WorkNav__["a" /* default */],{prev:prev,next:next}));}}]);return Lightblades;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Lightblades);

/***/ }),

/***/ 5065:
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(3149),
    baseFilter = __webpack_require__(5066),
    baseIteratee = __webpack_require__(3148),
    isArray = __webpack_require__(24);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 5066:
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(3150);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 5067:
/***/ (function(module, exports, __webpack_require__) {

var arraySample = __webpack_require__(5052),
    baseSample = __webpack_require__(5068),
    isArray = __webpack_require__(24);

/**
 * Gets a random element from `collection`.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 * @example
 *
 * _.sample([1, 2, 3, 4]);
 * // => 2
 */
function sample(collection) {
  var func = isArray(collection) ? arraySample : baseSample;
  return func(collection);
}

module.exports = sample;


/***/ }),

/***/ 5068:
/***/ (function(module, exports, __webpack_require__) {

var arraySample = __webpack_require__(5052),
    values = __webpack_require__(5019);

/**
 * The base implementation of `_.sample`.
 *
 * @private
 * @param {Array|Object} collection The collection to sample.
 * @returns {*} Returns the random element.
 */
function baseSample(collection) {
  return arraySample(values(collection));
}

module.exports = baseSample;


/***/ }),

/***/ 5069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ImageCopyBlock__ = __webpack_require__(5070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ImageCopyBlock__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ImageCopyBlock__["a"]; });


/***/ }),

/***/ 5070:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ImageCopyBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CopyImageBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimationWrapper__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Image__ = __webpack_require__(2057);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Video__ = __webpack_require__(5028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(5071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(23);
var ImageBlock=function ImageBlock(_ref){var item=_ref.item,theme=_ref.theme,side=_ref.side;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_6__styles__["e" /* image */],Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(side==='left'?__WEBPACK_IMPORTED_MODULE_6__styles__["g" /* left */]:__WEBPACK_IMPORTED_MODULE_6__styles__["i" /* right */]),Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(item.video?{width:'100%'}:{})),item.video?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Video__["a" /* default */],{videoId:item.video,sources:item.headerImage}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Image__["a" /* default */],{sources:item.headerImage,theme:theme}));};var CopyBlock=function CopyBlock(_ref2){var item=_ref2.item,theme=_ref2.theme,side=_ref2.side,showAllOnSmall=_ref2.showAllOnSmall,isInViewport=_ref2.isInViewport;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_6__styles__["a" /* copy */],Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(item.video?__WEBPACK_IMPORTED_MODULE_6__styles__["b" /* copyAfter */]:{}),Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(side==='right'?__WEBPACK_IMPORTED_MODULE_6__styles__["i" /* right */]:__WEBPACK_IMPORTED_MODULE_6__styles__["g" /* left */])),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AnimationWrapper__["a" /* default */],{inProp:isInViewport,transitionName:'slideUp',delay:150,once:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',Object.assign({},__WEBPACK_IMPORTED_MODULE_6__styles__["c" /* header */],Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(item.video?__WEBPACK_IMPORTED_MODULE_6__styles__["d" /* headerAfter */]:{})),item.title)),showAllOnSmall?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.excerpt):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',__WEBPACK_IMPORTED_MODULE_7__styles__["i" /* hideOnSm */],item.excerpt),item.cta&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],Object.assign({},__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* fillButton */],__WEBPACK_IMPORTED_MODULE_7__styles__["k" /* link */],__WEBPACK_IMPORTED_MODULE_6__styles__["h" /* linkStyles */],Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(theme&&theme.colors&&{'@media(min-width: 48em)':{color:theme.colors[0],background:theme.colors[1],transition:'all 0.2s'}}),Object(__WEBPACK_IMPORTED_MODULE_2_glamor__["css"])(theme&&theme.colors&&{'&:hover':{textDecoration:'none',color:'#fff',background:theme.colors[2]}}),__WEBPACK_IMPORTED_MODULE_7__styles__["i" /* hideOnSm */],{to:item.link}),item.cta));};var ImageCopyBlock=function ImageCopyBlock(_ref3){var item=_ref3.item,theme=_ref3.theme,_ref3$showAllOnSmall=_ref3.showAllOnSmall,showAllOnSmall=_ref3$showAllOnSmall===undefined?false:_ref3$showAllOnSmall,isInViewport=_ref3.isInViewport;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_6__styles__["f" /* itemStyles */],{'data-component':'ImageCopyBlock'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageBlock,{item:item,theme:theme,side:'left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CopyBlock,Object.assign({item:item,theme:theme,side:'right',showAllOnSmall:showAllOnSmall},isInViewport)));};var CopyImageBlock=function CopyImageBlock(_ref4){var item=_ref4.item,theme=_ref4.theme,_ref4$showAllOnSmall=_ref4.showAllOnSmall,showAllOnSmall=_ref4$showAllOnSmall===undefined?false:_ref4$showAllOnSmall,isInViewport=_ref4.isInViewport;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',Object.assign({},__WEBPACK_IMPORTED_MODULE_6__styles__["f" /* itemStyles */],{'data-component':'CopyImageBlock'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CopyBlock,Object.assign({item:item,theme:theme,side:'left'},isInViewport)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageBlock,{item:item,theme:theme,side:'right',showAllOnSmall:showAllOnSmall}));};

/***/ }),

/***/ 5071:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return image; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return right; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return itemStyles; });
/* unused harmony export backgroundImageStyles */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return linkStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return copy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return copyAfter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return headerAfter; });
/* unused harmony export absolute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_typography__ = __webpack_require__(36);
// const image = css({
//   width: '100%',
// });
var itemStyles=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({display:'flex',flexFlow:'column',alignItems:'center',justifyContent:'center',position:'relative',width:'100%',margin:'0 0 '+__WEBPACK_IMPORTED_MODULE_1__utils_typography__["a" /* default */].rhythm(2),'@media(min-width: 48em)':{flexFlow:'row'}});var backgroundImageStyles=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'absolute',top:0,left:0,width:'100%',height:'100%',backgroundColor:'red',backgroundSize:'cover',backgroundPosition:'center'});var linkStyles=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({color:'rgba(0, 0, 0, 0.8)',backgroundImage:'none',textShadow:'none','@media(max-width: 48em)':{color:'white'}});var image=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({flex:'1 0 60%',margin:0,'@media(max-width: 48em)':{flex:'1 0 100%'}});var left=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({order:1});var right=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({order:2});var copy=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({flex:'0 0 40%',position:'relative',padding:__WEBPACK_IMPORTED_MODULE_1__utils_typography__["a" /* default */].rhythm(2),paddingRight:__WEBPACK_IMPORTED_MODULE_1__utils_typography__["a" /* default */].rhythm(1),'@media(max-width: 48em)':{position:'absolute',flex:'1 0 100%',order:3,margin:0,padding:'2rem 4rem',color:'inherit',border:'1px solid rgba(255, 255, 255, 0.5)',zIndex:1}});var copyAfter={'@media(max-width: 48em)':{position:'relative',border:'none'}};var header=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({marginTop:0,'@media(max-width: 48em)':{color:'white'}});var headerAfter={'@media(max-width: 48em)':{color:'rgba(0, 0, 0, 0.8)'}};var absolute=Object(__WEBPACK_IMPORTED_MODULE_0_glamor__["css"])({position:'absolute',top:'-50%',left:'-50%',translate:'transform(-50%)'});

/***/ })

});


// WEBPACK FOOTER //
// static/js/0.f22a17e8.chunk.js